import React from 'react'
import { Box, Tabs, Flex, Text, Label, Heading } from '@workwhile/ui'
import { LeftEarlyQueue } from './LeftEarlyQueue'
import { AdminReviewQueue } from './AdminReviewQueue'
import { AdminReviewStatsChart } from './components/AdminReviewStatsChart/AdminReviewStatsChart'
import { useSearchParams } from 'react-router-dom'
import { useLeftEarlyShifts } from 'queries/review/useLeftEarlyShifts'
import { useAdminReviewShifts } from 'queries/review/useAdminReviewShifts'

export function ReviewPage() {
  const [searchParams, setSearchParams] = useSearchParams()

  // Fetch total counts for both tabs (no filters applied)
  const { data: leftEarlyData } = useLeftEarlyShifts({
    page: 0,
    pageSize: 1,
  })

  const { data: adminReviewData } = useAdminReviewShifts({
    page: 0,
    pageSize: 1,
  })

  const leftEarlyCount = leftEarlyData?.totalRows ?? 0
  const adminReviewCount = adminReviewData?.totalRows ?? 0

  return (
    <Box margin={3}>
      <Heading level={1} mb={3}>
        Admin Review
      </Heading>
      <Box mb={4}>
        <AdminReviewStatsChart />
      </Box>
      <Tabs
        defaultValue={searchParams.get('tab') || 'left_early'}
        onValueChange={(value) => {
          setSearchParams(new URLSearchParams({ tab: value }))
        }}
        tabs={[
          {
            value: 'left_early',
            label: (
              <Flex alignItems="center" gap={1} as="span">
                <Text as="span">Left Early</Text>
                <Label variant="warning" size="small" as="span">
                  {leftEarlyCount} to review
                </Label>
              </Flex>
            ) as any,
          },
          {
            value: 'admin_review',
            label: (
              <Flex alignItems="center" gap={1} as="span">
                <Text as="span">Admin Review</Text>
                <Label variant="warning" size="small" as="span">
                  {adminReviewCount} to review
                </Label>
              </Flex>
            ) as any,
          },
        ]}
      >
        <Tabs.Content value="left_early">
          <LeftEarlyQueue />
        </Tabs.Content>
        <Tabs.Content value="admin_review">
          <AdminReviewQueue />
        </Tabs.Content>
      </Tabs>
    </Box>
  )
}
